import { zodResolver } from '@hookform/resolvers/zod'
import { Box, Grid } from '@mui/material'
import { useCallback, useContext, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useSubmitOperacion } from '../../hooks/useSubmitOperacion'
import { ContextOperacionNuevo, ContextOperacionNuevoType } from '../../NuevoSistema'
import { HttpNOTES } from './api/httpNOTES'
import { SeccionNuevoNOTESDatosOperacion } from './components/SeccionNuevoNOTESDatosOperacion'
import { OperacionNOTESInsert, schemaOperacionNOTESInsert } from './types/dto'
import { OperacionNOTESFields } from './types/fields'
import SeccionNuevoNOTESDatosSecciones from './components/SeccionNuevoNOTESDatosSecciones'
import SeccionNuevoNOTESOtrosParametros from './components/SeccionNuevoNOTESOtrosParametros '
import SeccionNuevoNOTESArchivo from './components/SeccionNuevoNOTESArchivo '

interface NuevoSistemaNOTESProps {
  codSistemaPrincipal: number
}

const NuevoSistemaNOTES = ({ codSistemaPrincipal }: NuevoSistemaNOTESProps) => {
  const { submitOperacion } = useSubmitOperacion();

  const formMethods = useForm<OperacionNOTESInsert>({
    resolver: zodResolver(schemaOperacionNOTESInsert),
    defaultValues: {
      [OperacionNOTESFields.FechaSolicitud]: new Date(),
      [OperacionNOTESFields.CodPais]: codSistemaPrincipal,
      [OperacionNOTESFields.Parametros]: []
    }
  })



  const handleCrearOperacion = useCallback(
    (data: OperacionNOTESInsert) => {
      submitOperacion(data, {
        apiCall: HttpNOTES.post,
        codSistemaPrincipal,
      });
    },
    [codSistemaPrincipal, submitOperacion]
  );

  const { setSavePromise, setSendPromise, codSistema } = useContext<ContextOperacionNuevoType>(ContextOperacionNuevo)

  useEffect(() => {
    setSendPromise(() => formMethods.handleSubmit(handleCrearOperacion))
  }, [formMethods, handleCrearOperacion, setSavePromise, setSendPromise])


  return (
    <Box>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <SeccionNuevoNOTESDatosOperacion formMethods={formMethods} codSistema={codSistema} codPais={codSistemaPrincipal} />
        </Grid>
        <Grid item xs={12}>
          <SeccionNuevoNOTESDatosSecciones formMethods={formMethods} />
        </Grid>
        <Grid item xs={12}>
          <SeccionNuevoNOTESOtrosParametros formMethods={formMethods} />
        </Grid>
        <Grid item xs={12}>
          <SeccionNuevoNOTESArchivo formMethods={formMethods}/>
        </Grid>
      </Grid>
    </Box>
  )
}

export default NuevoSistemaNOTES
